import React from "react";
import { Container, Row, Col, Tab, Nav, Form, Button } from "react-bootstrap";
import "./DealerNetwork.css";
import Black_btn from "../common-components/common-button/black-btn/Black_btn";
import Form_component from "../contact_us/contact_form/Form_component";
import Common_Title_2 from "../common-components/common_title_2/Common_Title_2";

const DealerNetwork = () => {
  return (
    <section className="dealer_network_section">
      <Container>
        {/* Heading */}
        <div className="dealer_network_title">
          <Common_Title_2
            titleText="DEALER NETWORK"
            subText="Join Our Network"
            simpleText=" Become a part of our growing network of dealers, distributors, and
            business partners."
          />
        </div>
        <Form_component />
      </Container>
    </section>
  );
};

export default DealerNetwork;
